<template>
  <!-- <div class="connect_us_box animated slideInDown fadeOutUp" @click="handleClick"> -->
  <div class="connect_us_box animated"
       @click="handleClick">
    <div class="connect_us_content">
      <div class="out_connect_icon">
        <!-- <div class="connect_icon" @click="close()">联系我们</div> -->
      </div>
      <div class="content_info">
        <div class="left_connect_ways">
          <div class="connect_title">联系我们</div>
          <div class="wechat_info_box">
            <div class="wechat_icon">
              <img src="../assets/images/wechat_white_icon.png"
                   alt>
            </div>
            <div class="qrcode_box base_banner"
                 :style="{'background-image':'url('+comPath+contactInfo.qrcode+')'}"></div>
            <div class="wechat_info">
              扫码获取详细产品
              <br>资料与功能演示
            </div>
          </div>
          <div class="email_phone_com email">
            <div class="email_phone_com_icon">
              <img src="../assets/images/white_email.png"
                   alt>
            </div>
            <div class="email_phone_com_icon_info">{{this.contactInfo.email}}</div>
          </div>
          <div class="email_phone_com phone">
            <div class="email_phone_com_icon">
              <img src="../assets/images/white_phone.png"
                   alt>
            </div>
            <div class="email_phone_com_icon_info">{{this.contactInfo.phone}}</div>
          </div>
        </div>
        <div class="center_line">
          <div class="right_submit_connect_way">
            <div class="submit_title">您的联系方式</div>
            <div class="com_input name">
              <div class="left_input">
                <div class="left_input_icon">
                  <img class="person"
                       src="../assets/images/icon_person_white.png"
                       alt>
                </div>
              </div>
              <div class="right_input">
                <input type="text"
                       v-model="submitObj.name"
                       placeholder="请填写您的称呼">
              </div>
            </div>
            <div class="com_input">
              <div class="left_input">
                <div class="left_input_icon">
                  <img class="phone"
                       src="../assets/images/icon_phone_whiter.png"
                       alt>
                </div>
              </div>
              <div class="right_input">
                <input type="tel"
                       @blur="handlePhone"
                       v-model="submitObj.phone "
                       placeholder="请填写您的手机">
              </div>
            </div>
            <!-- <div class="com_input">
              <div class="left_input">
                <div class="left_input_icon">
                  <img class="email" src="../assets/images/icon_email_white.png" alt>
                </div>
              </div>
              <div class="right_input">
                <input
                  type="email"
                  @blur="handleEmail"
                  v-model="submitObj.email"
                  placeholder="请填写您的邮箱"
                >
              </div>
            </div> -->
            <div class="submit"
                 @click="submitMsg">提交</div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup"
         v-show="popupShow">
      <div class="success_tips"
           v-show="successShow">
        <div class="success_icon">
          <img src="../assets/images/success_icon.png"
               alt>
        </div>
        <div class="success_title">感谢咨询</div>
        <div class="success_info">
          我们已收到您的需求
          <br>稍后将有客户经理与您联系，请保持通信畅通
          <br>谢谢！
        </div>
        <div class="confirm"
             @click="confirm()">确定</div>
      </div>
      <div class="success_tips"
           v-show="errShow">
        <div class="success_icon">
          <img src="../assets/images/err_img.png"
               alt>
        </div>
        <div class="success_title">提交失败</div>
        <div class="success_info">
          非常抱歉，由于网络问题导致提交失败，
          <br>请重试！
        </div>
        <div class="confirm"
             @click="ErrConfirm()">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { Message } from "element-ui";

const mobileReg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
const emailReg = new RegExp(
  "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
);
export default {
  components: {},
  data () {
    return {
      contactInfo: {
        email: "",
        logimg: "",
        phone: "",
        qrcode: ""
      },
      submitObj: {},
      popupShow: false,
      successShow: false,
      errShow: false
    };
  },
  created () { },
  mounted () {
    this.getCcontactInfo();
  },
  methods: {
    //事件冒泡
    handleClick (e) {
      this.$emit("clickSelf", e);
    },
    parentHandleClick () {
      this.getCcontactInfo();
    },
    getCcontactInfo () {
      let url = "/api/home/gainglobalstyle";
      this.$http.get(url).then(res => {
        console.log(res);
        if (res.data.ret === 0) {
          this.contactInfo.email = res.data.lister[0].email;
          this.contactInfo.logimg = res.data.lister[0].logimg;
          this.contactInfo.phone = res.data.lister[0].phone;
          this.contactInfo.qrcode = res.data.lister[0].qrcode;
        }
        console.log(this.contactInfo);
      });
    },
    showTips (msg) {
      Message({
        showClose: true,
        message: msg,
        type: "error",
        duration: 1000,
        offset: 600
      });
    },
    confirm () {
      this.popupShow = false;
      this.successShow = false;
      this.$emit("closeFather");
    },
    ErrConfirm () {
      this.popupShow = false;
      this.errShow = false;
      this.$emit("closeFather");
    },
    close () {
      this.$emit("closeFather");
    },
    submitMsg () {
      //console.log(this.submitObj.email);
      if (!this.submitObj.name) {
        this.showTips("请填写您的称呼");
        return;
      }
      // if (!mobileReg.test(this.submitObj.phone) && !emailReg.test(this.submitObj.phone)) {
      if (!mobileReg.test(this.submitObj.phone)) {
        this.showTips("请输入正确的电话号码");
        return;
      }
      // if (!emailReg.test(this.submitObj.email)) {
      //   this.showTips("请填写您的邮箱");
      //   return;
      // }
      let url = "/api/home/msgsubmit";
      let usermsg = JSON.stringify({
        name: this.submitObj.name,
        phone: this.submitObj.phone,
        // email: this.submitObj.email
      });
      // console.log(usermsg);
      // console.log(qs.stringify(usermsg));
      this.$http
        .post(
          url,
          qs.stringify({
            usermsg: usermsg
          })
        )
        .then(
          res => {
            console.log(res);
            if (res.data.ret === 0) {
              for (const key in this.submitObj) {
                this.submitObj[key] = null;
              }
              this.popupShow = true;
              this.successShow = true;
            }
          },
          e => {
            this.popupShow = true;
            this.errShow = true;
          }
        );
    },
    handlePhone () {
      // if (!mobileReg.test(this.submitObj.phone) && !emailReg.test(this.submitObj.email)) {
      //   this.showTips("请输入正确的手机号码或正确的邮箱地址");
      // }
    },
    // handleEmail() {
    //   if (!emailReg.test(this.submitObj.email)) {
    //     this.showTips("请输入正确的邮箱");
    //   }
    // }
  }
};
</script>
<style lang="stylus" scoped>
@import '../assets/css/baseFontAndColor.styl'
input::-webkit-input-placeholder
  padding-left 14px
  color rgba(255, 255, 255, 0.5)
.connect_us_box
  width 100%
  height 500px
  background-color rgba(38, 38, 38, 0.97)
  // border-top 0.1px solid $color-theme-title
  .out_connect_icon
    display flex
    justify-content flex-end
    margin-top 15px
    height 30px
    .connect_icon
      width 80px
      height 30px
      border 1px solid #fff
      color #ffffff
      text-align center
      font-size @font-size-14
      line-height 30px
  .connect_us_content
    margin 0 auto
    width 1200px
    // height 500px
    // border-top 0.1px solid $color-theme-title
    .content_info
      display flex
      justify-content flex-start
      margin 0 auto
      margin-top 27px
      width 740px
      .left_connect_ways
        width 405px
        .connect_title
          height 28px
          color #fff
          font-size $font-size-20
          line-height 28px
        .wechat_info_box
          display flex
          justify-content flex-start
          margin-top 28px
          height 120px
          .wechat_icon
            width 58px
            height 58px
            img
              width 58px
              height 58px
          .qrcode_box
            margin-left 22px
            width 120px
            height 120px
            border-radius 6px
            background-color #fff
          .wechat_info
            margin-top 32px
            margin-left 20px
            color #fff
            font-size $font-size-16
        .email_phone_com
          display flex
          justify-content flex-start
          align-items center
          margin-top 48px
          height 58px
          .email_phone_com_icon
            width 58px
            height 58px
            img
              width 58px
              height 58px
          .email_phone_com_icon_info
            margin-left 22px
            color #ffffff
            font-weight lighter
            font-size 30px
        .phone
          margin-top 26px !important
      .center_line
        width 1px
        height 346px
        background linear-gradient(180deg, rgba(83, 125, 225, 0.2) 0%, rgba(255, 255, 255, 1) 49%, rgba(84, 127, 235, 0.2) 100%)
      .right_submit_connect_way
        margin-left 55px
        width 280px
        height 200px
        .submit_title
          height 28px
          color #ffffff
          font-size $font-size-20
          line-height 28px
        .com_input
          display flex
          justify-content flex-start
          align-items center
          margin-top 20px
          width 280px
          height 40px
          border 1px solid #fff
          .left_input
            display flex
            justify-content center
            align-items center
            width 40px
            height 40px
            background rgba(255, 255, 255, 0.3)
            .left_input_icon
              display flex
              justify-content center
              align-items center
              width 40px
              height 30px
              border-right 1px solid #fff
              .person
                width 14px
                height 16px
              .phone
                width 14px
                height 19px
              .email
                width 16px
                height 12px
          .right_input
            display flex
            justify-content center
            align-items center
            width 239px
            height 40px
            input
              padding-left 14px
              width 100%
              height 40px
              outline none
              border none
              background rgba(255, 255, 255, 0.3)
              color #fff
              line-height 38px
        .name
          margin-top 23px
        .submit
          margin-top 40px
          width 280px
          height 40px
          background-color #fff
          color #1088AF
          text-align center
          font-size 16px
          line-height 40px
          cursor pointer
.popup
  position fixed
  top 0
  right 0
  bottom 0
  left 0
  background rgba(38, 38, 38, 0.6)
  .success_tips
    position absolute
    top 220px
    left 50%
    width 380px
    height 330px
    // border-top 0.1px solid #fff
    border-radius 6px
    background #fff
    transform translateX(-50%)
    .success_icon
      margin 40px auto 0
      width 70px
      height 70px
      img
        width 70px
        height 70px
    .success_title
      margin-top 20px
      height 26px
      color $color-main-main
      text-align center
      font-size $font-size-18
      line-height 26px
    .success_info
      color $font-main-main
      text-align center
      font-size $font-size-14
      line-height 21px
    .confirm
      margin 30px auto
      width 220px
      height 40px
      background-color $color-theme-title
      color #fff
      text-align center
      font-size 16px
      line-height 40px
</style>



// WEBPACK FOOTER //
// src/views/connect_us.vue